<template>
  <div name="AnnouncementDetailInfo">
    <b-card class="card">
      <ErrorMessage :status="infoApiStatus.status" :customMessage="infoApiStatus.customMessage" />
      <template v-if="infoApiStatus.status === 200">
        <div class="announcement-header d-flex justify-content-between flex-wrap">
          <div class="reply-end">
            <span :class="isLimited">回答期限：</span>
            <span :class="isAlert">{{ selectedAnnouncement.display_ended_at }}</span>
            <SHIcons v-if="selectedAnnouncement.is_alert_ended" name="fire" iconColor="#e4634a" class="fire" width="30" height="30"/>
          </div>
          <span class="notice-date">通知日：{{ selectedAnnouncement.display_notice_date }}</span>
        </div>
        <h1 :class="['announcement-title', 'mt-3', titleClass]">
          {{ selectedAnnouncement.title }}
        </h1>

        <hr />
        <div class="announcement-footer d-flex justify-content-between flex-wrap">
          <span class="favorite" @click="handleClickFavorite(selectedAnnouncement.announcement_id, selectedAnnouncement.is_favorite)">
            <b-icon icon="suit-heart-fill" v-if="selectedAnnouncement.is_favorite === '1'" style="color: #e5414d;"></b-icon>
            <b-icon icon="suit-heart" v-else variant="secondary"></b-icon>
            いいね
          </span>
          <ReplyForm
            :key=selectedAnnouncement.announcement_id
            :options="selectedAnnouncement.options"
            :replyType="selectedAnnouncement.reply"
            :formComment="formComment"
            @click-reply="handleClickReply($event, selectedAnnouncement.announcement_id)"
          />
        </div>
      </template>
    </b-card>

    <!-- 詳細カード -->
    <b-card class="card" v-if="infoApiStatus.status === 200">
      <h2 class="card-title">詳細</h2>
        <div class="announcement-body">
          <ElementAutoLink :text="selectedAnnouncement.body"></ElementAutoLink>
        </div>
    </b-card>
  </div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue'
import ReplyForm from './ReplyForm'
import ElementAutoLink from '@/components/presentationals/ElementAutoLink'
import SHIcons from '@/components/ico/SHIcons'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AnnouncementDetail',

  components: {
    ReplyForm,
    ElementAutoLink,
    SHIcons,
    ErrorMessage
  },

  data() {
    return {
      formComment: ''
    }
  },

  computed: {
    ...mapState({
      infoApiStatus: state => state.Announcement.infoApiStatus
    }),
    ...mapGetters('Announcement/', ['selectedAnnouncement']),
    titleClass() {
      return {
        0: 'unread',
        1: 'read',
        2: 'replyed'
      }[this.selectedAnnouncement.status]
    },
    isAlert() {
      let classes = 'font-md'
      if (this.selectedAnnouncement.is_alert_ended) {
        classes += ' is_alert'
      }
      if (this.selectedAnnouncement.ended_at) {
        classes += ' limited'
      }
      return classes
    },
    isLimited() {
      return this.selectedAnnouncement.ended_at ? 'limited' : ''
    }
  },

  methods: {
    handleClickReply([replyType, comment], announcementId) {
      this.$emit('click-reply', {
        announcementId,
        replyType,
        comment
      })
    },
    handleClickFavorite(announcementId, isFavorite) {
      const toBeFavorite = isFavorite === '1' ? 0 : 1
      this.$emit('click-favorite', {
        announcementId,
        toBeFavorite
      })
    }
  },
  watch: {
    selectedAnnouncement() {
      this.formComment = this.selectedAnnouncement.comment
    }
  },
  mounted() {
    this.formComment = this.selectedAnnouncement.comment
  }
}
</script>

<style scoped>
.announcement-title {
  font-size: 28px;
  font-weight: bold;
}

.card-title{
  font-size: 22px;
  font-weight: bold;
}
.card {
  margin-bottom: 28px;
}

.announcement-title.unread:before {
  content: '●';
  color: #6bc3d4;
  font-size: 30px;
  margin-right: 5px;
}

.notice-date, .limit-title {
  font-size: 12px;
  display: inline-block;
  line-height: 24px;
}
.font-md{
  font-size: 18px;
}

.announcement-body {
  white-space: pre-wrap;
  padding: 5px;
  font-size: 14px;
}

.announcement-footer {
  padding: 5px;
  margin-top: 10px;
}

.favorite{
  margin-top:10px;
  margin-bottom:10px;
  height: 20px;
}
.favorite:hover {
  cursor: pointer;
}

.reply-end {
  font-size: 12px;
  position: relative;
  color: #e4634a;
  font-weight: bold;
}
.reply-end > .fire {
  position: absolute;
  right: -26px;
  top: -4px;
}
</style>
